exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullscreen[data-v-7ba5859c]{height:95vh;min-height:500px;max-height:1600px}.studio-area[data-v-7ba5859c]{background:url(\"/static/img/hypnotize.png\") repeat}.studio-area .overlay-bg[data-v-7ba5859c]{background:rgba(36,82,112,.8)}.studio-thumb img[data-v-7ba5859c]{-webkit-filter:grayscale(100%) contrast(1.25);filter:grayscale(100%) contrast(1.25)}.achivement-area[data-v-7ba5859c]{padding:50px}#mc_embed_signup[data-v-7ba5859c]{margin-top:50px}@media (max-width:767.98px){.achivement-area[data-v-7ba5859c]{padding-bottom:100px}}@media (max-width:575.98px){.achivement-area img[data-v-7ba5859c]{display:none;visibility:hidden}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5859c","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Home.vue
// module id = wR41
// module chunks = 1